module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-group.ce6f2ac4.png";